const creativeCommonsLicensesURL = 'https://creativecommons.org/licenses';
const creativeCommonsVersion = '4.0';

const LICENSE_TYPE = {
  allRightsReserved: 'all-rights-reserved',
  creativeCommons: 'creative-commons',
};

const LICENSE_COMMONS_OPTIONS = {
  attribution: 'BY',
  nonCommercial: 'NC',
  noDerivatives: 'ND',
  shareAlike: 'SA',
};

export {
  LICENSE_TYPE, LICENSE_COMMONS_OPTIONS, creativeCommonsLicensesURL, creativeCommonsVersion,
};
